import Vue from 'vue'

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})



// WEBPACK FOOTER //
// ./src/config/event-bus.js